const WATERMARK_TEXT = '高金智库数据资产研究课题组';
const WATERMARK_FONT = 'bold 20px "PingFang SC", "Microsoft YaHei", "Noto Sans SC", sans-serif';
export const WATERMARK_ID_PREFIX = 'chart-canvas-wm-';

const POSITIONS = [
  { left: '15%', top: '20%' },
  { left: '50%', top: '50%' },
  { left: '75%', top: '70%' },
];

function watermarkSize() {
  if (typeof document === 'undefined') return { width: 280, height: 20 };
  const ctx = document.createElement('canvas').getContext('2d');
  ctx.font = WATERMARK_FONT;
  return { width: ctx.measureText(WATERMARK_TEXT).width, height: 20 };
}

export function watermarkGraphicElements() {
  const { width, height } = watermarkSize();
  return POSITIONS.map((position, index) => ({
    id: `${WATERMARK_ID_PREFIX}${index}`,
    type: 'text',
    left: position.left,
    top: position.top,
    rotation: -Math.PI / 6,
    origin: [width / 2, height / 2],
    silent: true,
    z: 1000,
    style: {
      text: WATERMARK_TEXT,
      fill: 'rgba(0, 0, 0, 0.06)',
      font: WATERMARK_FONT,
      textAlign: 'left',
      textVerticalAlign: 'top',
    },
  }));
}

export function appendWatermark(option) {
  if (!option) return option;
  const existing = option.graphic == null
    ? []
    : (Array.isArray(option.graphic) ? option.graphic : [option.graphic]);
  const kept = existing.filter((item) => !item || String(item.id || '').indexOf(WATERMARK_ID_PREFIX) !== 0);
  option.graphic = kept.concat(watermarkGraphicElements());
  return option;
}

export function removeWatermarkOption() {
  return {
    graphic: watermarkGraphicElements().map((item) => ({
      id: item.id,
      $action: 'remove',
    })),
  };
}

export function restoreWatermarkOption() {
  return { graphic: watermarkGraphicElements() };
}
